// @vendor
const { combineReducers } = require('redux');
const { routerReducer } = require('react-router-redux');

// @commons
const actionTypes = require('constants/actionTypes');

// @reducers
const brokerInvestmentFunds = require('ok-funds-card/reducers/brokerInvestmentFunds');
const brokerInvestmentFundView = require('ok-funds-card/reducers/brokerInvestmentFundView');
const brokerMyInvestments = require('./brokerMyInvestments');
const flagBasedFeatures = require('./flagBasedFeatures');
const globalVariables = require('./globalVariables');
const glossary = require('./glossary');
const profile = require('./profile');
const translations = require('./translations');

const reducers = {
    brokerInvestmentFunds,
    brokerInvestmentFundView,
    brokerMyInvestments,
    flagBasedFeatures,
    globalVariables,
    glossary,
    profile,
    translations,
}; //Please keep these arguments alphabetically ordered

const appReducer = combineReducers(reducers);

const rootReducer = (state, action) => {
    return appReducer(state, action);
};

module.exports = rootReducer;
